import { useOutletContext } from 'react-router-dom';
import type { Tenant, Workspace, PaymentEvent, StaffAuditEntry } from '@/data/types';

export interface TenantOutletContext {
  tenant: Tenant;
  workspaces: Workspace[];
  payments: PaymentEvent[];
  audit: StaffAuditEntry[];
}

export function useTenant() {
  return useOutletContext<TenantOutletContext>();
}
